export default "__VITE_ASSET__caf6b7f5__"